<template>
  <div class="mb-5">
    <PaymentWidgetWithoutStore
      :payment="newPaymentParameters"
      :assetComponent="assetComponent"
      :unitOfMeasure="assetComponentUnitOfMeasure"
      :validationErrors="validationErrors"/>
  </div>
</template>

<script>
import AddPaymentParameters from "../../models/commands/AddPaymentParameters";
import PaymentParameters from "../../../assetComponent/models/PaymentParameters";
import dateConverter from "../../../../utils/converters/date.converter";

export default {
  props: {
    assetComponent: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newPaymentParameters: {},
      validationErrors: []
    };
  },
  created() {
    this.init();
  },
  computed: {
    assetComponentUnitOfMeasure() {
      let unitOfMeasure = this.assetComponent.unitOfMeasureCode;
      if (unitOfMeasure === null) {
        return null;
      } else {
        return this.$t("CONTENT." + unitOfMeasure);
      }
    },
  },
  methods: {
    cancel() {
      this.init();
    },

    init() {
      this.newPaymentParameters = PaymentParameters.createNew();
    },
    save() {
      if (this.newPaymentParameters == null)
        throw new Error("newPaymentParameters cannot be null");

      if (!this.validate()) {
        this.$toast.error(this.$t('NOTIFY.fill_required_fields'));
        this.$nextTick(() => {
          const errorEl = this.$el.querySelector('.dropdown.error, .b-datepicker__error, .b-numeric__error');
          if (errorEl) errorEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
        return false;
      }


      this.$eventBus.$emit('saveNewPayment', {
        newPayment: this.newPaymentParameters,
        assetComponentId: this.assetComponent.idInDB,
        lessorComponentShareId: this.newPaymentParameters.lessorComponentShareId,
        isEvent: true});

      let firstIndexationDateAsDate = null;
      let firstIndexationDateAsDay = null;
      let firstIndexationDateAsMonth = null;
      let firstIndexationDateAsYear = null;

      if(this.newPaymentParameters.indexation.firstIndexationDate !== null) {
        firstIndexationDateAsDate = dateConverter.convertToDate(this.newPaymentParameters.indexation.firstIndexationDate);
        firstIndexationDateAsDay = this.$moment(firstIndexationDateAsDate).format('DD');
        firstIndexationDateAsMonth = this.$moment(firstIndexationDateAsDate).format('MM');
        firstIndexationDateAsYear = this.$moment(firstIndexationDateAsDate).format('YYYY');
      }

      const startDateAsDate = dateConverter.convertToDate(this.newPaymentParameters.startDate);
      const endDateAsDate = dateConverter.convertToDate(this.newPaymentParameters.endDate);
      const firstPaymentDateAsDate = dateConverter.convertToDate(this.newPaymentParameters.firstPaymentDate);

      const transformedPaymentForCommand = {
        externalId: this.newPaymentParameters.externalId,
        lessorComponentShareId: this.newPaymentParameters.lessorComponentShareId,
        paymentNameId: this.newPaymentParameters.paymentNameId,
        currencyRateParameters: this.newPaymentParameters
          .currencyRateParameters,
        currencyCode: this.newPaymentParameters.currencyCode,
        leaseRate: this.newPaymentParameters.leaseRate,
        leaseFrequency: this.newPaymentParameters.leaseFrequency,
        startDateDay: this.$moment(startDateAsDate).format('DD'),
        startDateMonth: this.$moment(startDateAsDate).format('MM'),
        startDateYear: this.$moment(startDateAsDate).format('YYYY'),
        endDateDay:  this.$moment(endDateAsDate).format('DD'),
        endDateMonth: this.$moment(endDateAsDate).format('MM'),
        endDateYear: this.$moment(endDateAsDate).format('YYYY'),
        paymentFrequency: this.newPaymentParameters.paymentFrequency,
        firstPaymentDateDay: this.$moment(firstPaymentDateAsDate).format('DD'),
        firstPaymentDateMonth: this.$moment(firstPaymentDateAsDate).format('MM'),
        firstPaymentDateYear: this.$moment(firstPaymentDateAsDate).format('YYYY'),
        isLastPeriodDate: this.newPaymentParameters.isLastPeriodDate,
        indexation: {
          firstIndexationDateDay: firstIndexationDateAsDay,
          firstIndexationDateMonth: firstIndexationDateAsMonth,
          firstIndexationDateYear: firstIndexationDateAsYear,
          indexationPercent: this.newPaymentParameters.indexation.indexationPercent,
          commentary: this.newPaymentParameters.indexation.commentary,
          indexationKindId: this.newPaymentParameters.indexation.indexationKindId,
        },
        discount: {
          discountRate: this.newPaymentParameters.discount.discountRate,
          isAuto: this.newPaymentParameters.discount.isAuto,
          commentary: this.newPaymentParameters.discount.commentary,
        }
      };

      const command = new AddPaymentParameters(transformedPaymentForCommand);

      this.$store.commit("eventRegistryPlugin/addOrUpdateCommand", command);
      return true;
    },
    validate() {
      this.validationErrors = [];
      let payment = _.cloneDeep (this.newPaymentParameters);
      if (!payment.lessorComponentShareId) {
        this.validationErrors.push("lessorComponentShareId");
      }
      if (!payment.paymentNameId) {
        this.validationErrors.push("paymentNameId");
      }
      if (!payment.currencyCode) {
        this.validationErrors.push("currencyCode");
      }
      if (!payment.leaseFrequency) {
        this.validationErrors.push("leaseFrequency");
      }
      if (!payment.startDate) {
        this.validationErrors.push("startDate");
      }
      if (!payment.endDate) {
        this.validationErrors.push("endDate");
      }
      if (!payment.firstPaymentDate) {
        this.validationErrors.push("firstPaymentDate");
      }
      if (!payment.paymentFrequency) {
        this.validationErrors.push("paymentFrequency");
      }
      if (!payment.indexation || !payment.indexation.indexationKindId) {
        this.validationErrors.push("indexationKindId");
      }
      if (!payment.discount || (!payment.discount.isAuto && (payment.discount.discountRate === null || payment.discount.discountRate === undefined))) {
        this.validationErrors.push("discountPercent");
      }
      if (payment.leaseRate === null || payment.leaseRate === undefined) {
        this.validationErrors.push("leaseRate");
      }
      if (!payment.currencyRateParameters.type) {
        this.validationErrors.push("currencyCodeType");
      }
      return this.validationErrors.length <= 0;
    }
  }
};
</script>

<style>
</style>
